export default __webpack_public_path__ + "static/media/banner.02d60074.jpg";